<template>
    <div class="container-fluid" style="background-color: white;">
        <!--button submit-->
        <div class="row">
            <div class="col text-right">
                <button class="btn btn-default margin next"
                        @click="goToEmployeeSalary">
                    <icon name="forward"></icon>
                    ถัดไป
                </button>
                <button class="btn btn-success margin"
                        @click="showConfirmModal">
                    <icon name="save"></icon>
                    บันทึกจบ
                </button>
                <button class="btn btn-danger margin" @click="goToEmployeeList">
                    <icon name="times"></icon>
                    ยกเลิก
                </button>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-10 border border-dark">
                <h5>ข้อมูลส่วนบุคคล</h5>
                <div v-if="validate_employee_no" style="font-size: 15px; color: red">
                    **รหัสพนักงานซ้ำกับ {{ validate_employee_no }}
                </div>
                <div class="row form-inline padding">
                    <div class="form-group padding">
                        <label for="employee_no">รหัสพนักงาน</label>
                        <input class="form-control" id="employee_no"
                               v-model="form.employee_no"
                               placeholder="รหัสพนักงาน">
                        <button type="button" class="btn btn-danger"
                                @click="validateEmployeeNo"
                                v-if="!form.id">
                            ตรวสอบรหัสซ้ำ
                        </button>
                    </div>
                    <div class="form-group padding">
                        <label>
                            เพศ <span style="color: red ; font-weight: bold">*</span>
                        </label>
                        <b-form-select v-model="form.sex_id" :options="sex">
                        </b-form-select>
                    </div>
                    <div class="form-group padding">
                        <label>
                            คำนำหน้า <span style="color: red ; font-weight: bold">*</span>
                        </label>
                        <b-form-select v-model="form.prefix" :options="prefix">
                        </b-form-select>
                    </div>
                    <div class="form-group padding">
                        <label for="first_name">
                            ชื่อจริง <span style="color: red ; font-weight: bold">*</span>
                        </label>
                        <input class="form-control" id="first_name"
                               v-model="form.first_name"
                               placeholder="ชื่อจริง">
                    </div>
                    <div class="form-group padding">
                        <label for="last_name">
                            นามสกุล <span style="color: red ; font-weight: bold">*</span>
                        </label>
                        <input class="form-control" id="last_name"
                               v-model="form.last_name"
                               placeholder="นามสกุล">
                    </div>
                    <div class="form-group padding">
                        <label for="english_name">ชื่อ-สกุล ภาษาอังกฤษ</label>
                        <input class="form-control" id="english_name"
                               v-model="form.english_name"
                               placeholder="ชื่อ-สกุล ภาษาอังกฤษ">
                    </div>
                    <div class="form-group padding">
                        <label>สถานภาพ</label>
                        <b-form-select v-model="form.marital_status" :options="marital">
                        </b-form-select>
                    </div>
                    <div class="form-group padding">
                        <label for="tax_id">เลขประจำตัวผู้เสียภาษี</label>
                        <input class="form-control" id="tax_id"
                               v-model="form.tax_number"
                               placeholder="เลขประจำตัวผู้เสียภาษี">
                    </div>
                    <div class="form-group padding">
                        <label>
                            วัน/เดือน/ปี เกิด <span style="color: red ; font-weight: bold">*</span>
                        </label>
                        <date-picker v-model="form.birthday" id="birthday"
                                     :lang="lang"
                                     :format="changeFormat"
                                     placeholder="วัน/เดือน/ปี เกิด">
                        </date-picker>
                    </div>
                    <div class="form-group padding">
                        <label>
                            อายุ <span style="color: red ; font-weight: bold">*</span>
                        </label>
                        <input class="form-control"
                               type="number"
                               v-model="form.age"
                               placeholder="อายุ">
                    </div>
                    <input type="hidden" v-model="age"/>
                    <div class="form-group">
                        <b-form-file
                            ref="file_upload"
                            @change="FileUploadPDF"
                            class="w-100"
                            placeholder="อัพโหลดไฟล์">
                        </b-form-file>
                    </div>
                    <div class="form-group padding">
                        <div v-if="form.id && typeof(form.file_upload)=='string' ">
                            <a :href="form.file_upload" style="color: red" target="_blank">
                                <icon name="file-pdf"></icon>
                                ดูไฟล์ PDF
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-sm-2">
                <div v-if="form.image.length > 0">
                    <template v-for="img in form.image">
                        <img :src="img.path?img.path:img" class="img-thumbnail" alt="upload">
                    </template>
                </div>
                <div v-else>
                    <img src="@/assets/upload.png" class="img-thumbnail" alt="upload">
                </div>
                <!--                <b-form-file v-model="file" @change="uploadImage"-->
                <!--                             class="mt-3" accept="image/*" plain>-->
                <!--                </b-form-file>-->
                <image-uploader @input="uploadImage"
                                accept="image/*"
                                :maxWidth="1024"
                                :maxHeight="1024"
                                :quality="0.9"
                                :preview="false">
                </image-uploader>
            </div>
        </div>
        <br/>
        <div class="row">
            <div class="col-sm-6 border border-dark">
                <h5>บัตรประชาชน / passport</h5>
                <div class="row form-group">
                    <div class="col-6 text-right">
                        <label>
                            เลขบัตรประชาชน/ passport <span style="color: red ; font-weight: bold">*</span>
                        </label>
                    </div>
                    <div class="col-6">
                        <input type="text" class="form-control"
                               v-model="form.citizen.citizen_id"
                               placeholder="เลขบัตรประชาชน"/>
                        <button type="button" class="btn btn-outline-success"
                                v-if="!form.id"
                                @click="validatePassportNumber">
                            ตรวสอบรหัสซ้ำ
                        </button>
                    </div>
                </div>
                <template v-if="form.citizen.citizen_id_history != null">
                    <div class="row form-group" v-for="(x,i) in form.citizen.citizen_id_history.split(',')">
                        <div class="col-6 text-right">
                            <label>
                                เล่มที่ {{ i + 1 }}
                            </label>
                        </div>
                        <div class="col-6">
                            <input type="text" class="form-control"
                                   :value="x"
                                   readonly/>
                        </div>
                    </div>
                </template>
                <div class="row form-group" v-if="validate_passport">
                    <div class="col-6 text-right text-danger">**ชื่อพนักงานที่ซ้ำ :</div>
                    <div class="col-6 text-danger">
                        {{ validate_passport ? validate_passport.employee_name : '' }}
                    </div>
                </div>
                <div class="row form-group">
                    <b-col sm="5" class="col-sm-5">
                        <div class="form-inline float-right">
                            <label for="nationality1">คนไทย</label>
                            <input type="radio"
                                   value="1"
                                   id="nationality1"
                                   v-model="form.nationality.nationality"/>
                            <label for="nationality2">ต่างชาติ</label>
                            <input type="radio"
                                   value="2"
                                   id="nationality2"
                                   v-model="form.nationality.nationality"/>
                        </div>
                    </b-col>
                    <b-col sm="4" class="col-sm-4">
                        <b-form-select :options="optionPassportType" v-model="form.nationality.passport_type_id"
                                       :disabled="form.nationality.nationality == 1">
                        </b-form-select>
                    </b-col>
                    <b-col sm="3" class="col-sm-3">
                        <div class="form-button">
                            <button class="btn btn-success"
                                    @click="showModalAddNation"
                                    style="font-size: 10px">
                                <icon name="save" style="width: 15px"></icon>
                                สัญชาติ
                            </button>
                        </div>
                    </b-col>

                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>วันหมดอายุ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <date-picker v-model="form.citizen.expire_date"
                                     :lang="lang"
                                     class="w-100"
                                     :format="changeFormat"
                                     placeholder="วันหมดอายุ">
                        </date-picker>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>ออกให้ ณ</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input type="text" class="form-control"
                               v-model="form.citizen.issue_at"
                               placeholder="ออกให้ ณ"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="6" class="col-sm-6 text-right">
                        <label>กลุ่มสังกัด</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6 form-inline">
                        <input type="radio" value='0'
                               id="group1"
                               v-model="form.nationality.group_employee"/>
                        <label for="group1">ไม่เลือก</label>
                        <input type="radio" value="1"
                               id="group2"
                               v-model="form.nationality.group_employee"/>
                        <label for="group2">A</label>
                        <input type="radio" value="2"
                               id="group3"
                               v-model="form.nationality.group_employee"/>
                        <label for="group3">B</label>
                    </b-col>
                </div>
                <br/>
                <div>
                    <h5>สถานภาพพนักงาน</h5>
                    <div class="row form-group">
                        <div class="col-sm-6 text-right">
                            วันที่เริ่ม VISA
                        </div>
                        <div class="col-sm-6">
                            <date-picker v-model="form.work_status.visa_date"
                                         :lang="lang"
                                         class="w-100"
                                         :format="changeFormat"
                                         placeholder="วันที่เริ่ม VISA">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-6 text-right">
                            วันที่หมดอายุ VISA
                        </div>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.work_status.visa_expire_date"
                                :lang="lang"
                                class="w-100"
                                :format="changeFormat"
                                placeholder="วันที่หมดอายุ VISA">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-6 text-right">
                            วันที่เริ่มใบอนุญาตทำงาน
                        </div>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.work_status.certificate_date"
                                :lang="lang"
                                class="w-100"
                                :format="changeFormat"
                                placeholder="วันที่เริ่มใบอนุญาตทำงาน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-6 text-right">
                            วันที่หมดอายุใบอนุญาตทำงาน
                        </div>
                        <div class="col-sm-6">
                            <date-picker
                                v-model="form.work_status.certificate_expire_date"
                                :lang="lang"
                                class="w-100"
                                :format="changeFormat"
                                placeholder="วันที่หมดอายุใบอนุญาตทำงาน">
                            </date-picker>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-6 text-right">
                            ทร.38
                        </div>
                        <div class="col-sm-6">
                            <input class="form-control" placeholder="ทร.38"
                                   v-model="form.work_status.myanmar_list"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>สถานภาพการทำงาน <span style="color: red ; font-weight: bold">*</span></label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <b-form-select v-model="form.work_status.active_status_id"
                                           :disabled="form.work_status.active_status_id == 2 && !canViewSuperAdmin"
                                           :options="active">
                            </b-form-select>
                        </b-col>
                    </div>
                    <!--<div class="row form-group">-->
                    <!--<b-col sm="6" class="col-sm-6 text-right">-->
                    <!--<label>วันที่ทำงาน</label>-->
                    <!--</b-col>-->
                    <!--<b-col sm="6" class="col-sm-6">-->
                    <!--<date-picker-->
                    <!--class="w-100"-->
                    <!--v-model="form.work_status.start_work_date"-->
                    <!--lang="en"-->
                    <!--placeholder="วันที่เริ่มทำงาน">-->
                    <!--</date-picker>-->
                    <!--</b-col>-->
                    <!--</div>-->
                    <div class="row form-group" v-if="form.work_status.active_status_id == 2">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>วันที่ลาออก</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <date-picker
                                class="w-100"
                                v-model="form.work_status.resign_date"
                                :lang="lang"
                                :format="changeFormat"
                                placeholder="วันที่ลาออก">
                            </date-picker>
                        </b-col>
                    </div>
                    <div class="row form-group"
                         v-if="form.work_status.active_status_id == 2 || form.work_status.active_status_id == 3">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>เหตุผล</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <b-form-select v-model="form.work_status.reason"
                                           :options="reason">
                            </b-form-select>
                        </b-col>
                    </div>
                    <div class="row form-group" v-if="form.work_status.reason == 'อื่นๆ'">
                        <b-col sm="6" class="col-sm-6 text-right">
                            <label>อื่นๆ</label>
                        </b-col>
                        <b-col sm="6" class="col-sm-6">
                            <input type="text" class="form-control"
                                   v-model="form.work_status.reason_txt"
                                   placeholder="เหตุผล"/>
                        </b-col>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 border border-dark">
                <h5>ที่อยู่ปัจจุบัน</h5>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>ที่อยู่ปัจจุบัน เลขที่</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control" placeholder="เลขที่"
                               v-model="form.address.house_no"
                               type="text"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>หมู่ที่</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control"
                               v-model="form.address.village_no"
                               placeholder="หมู่ที่" type="text"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>ถนน</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control"
                               v-model="form.address.road"
                               placeholder="ถนน" type="text"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>จังหวัด</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <multiselect
                            v-model="form.address.province"
                            @input="getDistricts(form.address.province)"
                            :options="optionProvince"
                            :show-labels="false"
                            label="name"
                            placeholder="เลือกจังหวัด"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>อำเภอ / เขต</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <multiselect
                            v-model="form.address.district"
                            :options="optionDistricts"
                            :show-labels="false"
                            @input="getSubDistricts(form.address.district)"
                            label="name"
                            placeholder="เลือกอำเภอ / เขต"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>ตำบล / แขวง</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <multiselect
                            v-model="form.address.sub_district"
                            :options="optionSubDistricts"
                            :show-labels="false"
                            label="name"
                            placeholder="เลือกแขวง / ตำบล"
                            track-by="name">
                        </multiselect>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>รหัสไปรษณีย์</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control" placeholder="รหัสไปรษณีย์"
                               v-model="postal_code"
                               type="text" readonly/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>อีเมล</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <input class="form-control"
                               v-model="form.address.email"
                               placeholder="อีเมล" type="text"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>เบอร์โทร 1</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <masked-input v-model="form.address.phone1"
                                      mask="111-111-1111"
                                      placeholder=" เบอร์โทร 1"
                                      class="form-control"
                                      type="tel"/>
                    </b-col>
                </div>
                <div class="row form-group">
                    <b-col sm="4" class="col-sm-4 text-right">
                        <label>เบอร์โทร 2</label>
                    </b-col>
                    <b-col sm="6" class="col-sm-6">
                        <masked-input v-model="form.address.phone2"
                                      mask="111-111-1111"
                                      placeholder=" เบอร์โทร 2"
                                      class="form-control"
                                      type="tel"/>
                    </b-col>
                </div>
            </div>
        </div>
        <b-modal hide-header hide-footer ref="confirmEmp">
            <confirm-emp-modal @submit="saveEmployee">
            </confirm-emp-modal>
        </b-modal>
        <!-- Modal showModalAddPack -->
        <b-modal hide-header hide-footer ref="add_nation">
            <div style="text-align: center;">
                <div>
                    <label style="color: red;font-size: 14px">**กรอกสัญชาติที่ต้องการเพิ่ม/ลบ</label><br/>
                    <label style="color: red;font-size: 14px">**เช่น ต้องการลบสัญชาติ พม่าเหลือง ให้กรอกคำว่า พม่าเหลือง
                        แล้วกดลบ</label><br/>
                    <input
                        type="text"
                        class="form-control"
                        v-model="nation"/>
                </div>
                <br/>
                <button @click="addNation"
                        type="button"
                        class="btn btn-success">
                    เพิ่ม
                </button>
                &nbsp&nbsp
                <button @click="deleteNation"
                        type="button"
                        class="btn btn-danger">
                    ลบ
                </button>
                &nbsp&nbsp
                <button @click="hideModalAddNation"
                        type="button"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <!--<pre class="alert alert-danger text-left">{{form}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import DatePicker from 'vue2-datepicker'
import Multiselect from "vue-multiselect";
import moment from "moment";
import MaskedInput from 'vue-masked-input'
import confirmEmpModal from "../../../Utility/ConfirmEmpModal";
import ImageUploader from "vue-image-upload-resize";

import {canViewSuperAdmin} from "../../../../util/Permissions";

export default {
    name: "employee-data",
    props: {
        id: {default: null}
    },
    components: {
        DatePicker,
        Multiselect,
        MaskedInput,
        confirmEmpModal,
        ImageUploader
    },
    data() {
        return {
            nationality: [
                {text: "เลือกสัญชาติ", value: ""},
                {text: "คนไทย", value: 1},
                {text: "ต่างชาติ", value: 2},
            ],
            active: [
                {text: "เลือกสถานะการทำงาน", value: "", disabled: true},
                {text: "พนักงาน", value: 1},
                {text: "ลาออก", value: 2},
                {text: "รออนุมัติ", value: 3, disabled: true},
            ],
            reason: [
                {text: "เลือกเหตุผล", value: "ไม่เลือก"},
                {text: "ลาออก/โดยติดต่อลากับนายจ้าง", value: 'ลาออก/โดยติดต่อลากับนายจ้าง'},
                {text: "สิ้นสุดการจ้าง", value: "สิ้นสุดการจ้าง"},
                {text: "เลิกจ้าง/ขาดงานติดต่อ 3 วัน", value: "เลิกจ้าง/ขาดงานติดต่อ 3 วัน"},
                {text: "เกษียณอายุ", value: "เกษียณอายุ"},
                {text: "ไล่ออก/ปลดออก เนื่องจากกระทำความผิด", value: "ไล่ออก/ปลดออก เนื่องจากกระทำความผิด"},
                {text: "เสียชีวิต", value: "เสียชีวิต"},
                {text: "อื่นๆ", value: "อื่นๆ"},
            ],
            reason_txt: '',
            sex: [
                {text: "เลือกเพศ", value: ""},
                {text: "ชาย", value: 1},
                {text: "หญิง", value: 2}
            ],
            prefix: [
                {text: "เลือกคำนำหน้า", value: ""},
                {text: "นาย", value: 1},
                {text: "นาง", value: 2},
                {text: "นางสาว", value: 3}
            ],
            marital: [
                {text: "เลือกสถานะ", value: ""},
                {text: "หย่าร้าง", value: 1},
                {text: "แต่งงานแล้ว", value: 2},
                {text: "โสด", value: 3}
            ],
            file: "",
            nation: "",
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            validate_passport: '',
            validate_employee_no: '',
        }
    },
    created() {
        this.$store.dispatch('Common/setProvince');
        this.$store.dispatch('Common/getPassportType');
        this.differentDate();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            form: state => {
                return state.Employee.employeeForm;
            },
            optionProvince: state => {
                return state.Common.province;
            },
            optionDistricts: state => {
                return state.Common.districts;
            },
            optionSubDistricts: state => {
                return state.Common.sub_districts;
            },
            user: state => {
                return state.Auth.user;
            },
            optionPassportType: state => {
                return [
                    {
                        value: null,
                        text: "เลือกสัญชาติพนักงาน"
                    },
                    ...state.Common.passport_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ]
            }
        }),
        age() {
            this.differentDate();
        },
        postal_code() {
            let zipcode = '';
            if (this.form.address.district && this.form.address.sub_district) {
                zipcode = this.form.address.sub_district.zipcode;
                return zipcode;
            } else {
                return zipcode;
            }
        }
    },
    methods: {
        showModalAddNation() {
            this.pack = '';
            this.$refs.add_nation.show();
        },
        hideModalAddNation() {
            this.$refs.add_nation.hide();
        },
        addNation() {
            if (this.nation) {
                let data = {
                    nation: this.nation
                };
                this.$store.dispatch('Employee/addNation', data).then(() => {
                    window.location.reload();
                });
            }
        },
        deleteNation() {
            if (this.nation) {
                let data = {
                    nation: this.nation
                }
                this.$store.dispatch('Employee/deleteNation', data).then(() => {
                    window.location.reload();
                });
            }
        },
        showConfirmModal() {
            this.$refs.confirmEmp.show();
        },
        deleteRE(value) {
            if (value) {
                this.$store.dispatch("BillingRE/deleteBillingRE", this.delete_id).then(() => {
                    alert('ลบรายการสำเร็จ');
                    this.getBillingREPage(1);
                }).catch(() => {
                    alert('ลบรายการไม่สำเร็จ');
                })
            }
            this.hideDeleteModal();
        },
        getDistricts(province) {
            this.form.address.district = "";
            this.form.address.sub_district = "";
            if (province) {
                //console.log(province.code);
                this.$store.dispatch('Common/setDistrict', province.code);
            } else {
                this.form.address.district = "";
                this.form.address.sub_district = "";
            }
        },
        getSubDistricts(districts) {
            this.form.address.sub_district = "";
            if (districts) {
                this.$store.dispatch('Common/setSubDistrict', districts.district_id);
            } else {
                this.form.address.sub_district = "";
            }
        },
        uploadImage(file) {
            // this.form.image = [];
            // let input = event.target;
            // for (let i = 0; i < input.files.length; i++) {
            //     if (input.files && input.files[i]) {
            //         let reader = new FileReader();
            //         reader.onload = e => {
            //             this.form.image.push({
            //                 path : e.target.result,
            //             });
            //         };
            //         reader.readAsDataURL(input.files[i]);
            //     }
            // }
            //console.log(file)
            this.form.image = [];
            this.form.image.push(file);
        },
        FileUploadPDF: function () {
            let input = event.target;
            this.form.file_upload = input.files[0];
        },
        goToEmployeeList(value) {
            this.$router.push({
                name: "employee"
            })
        },
        saveEmployee(value) {
            if (value) {
                this.form.user_id = this.user.id;
                if (this.validateData()) {
                    this.$store.dispatch("Employee/saveEmployee", {
                        id: this.form.id,
                        data: this.form
                    });
                    this.goToEmployeeList();
                }
            } else {
                this.$refs.confirmEmp.hide();
            }
        },
        goToEmployeeSalary() {
            if (this.validateData()) {
                this.$router.push({
                    name: "employee-information-salary"
                });
            }
        },
        validateData() {
            if (!this.form.sex_id) {
                alert("กรุณาเลือกเพศ")
            } else if (!this.form.prefix) {
                alert("กรุณาเลือกคำนำหน้าชื่อ")
            } else if (!this.form.first_name) {
                alert("กรุณาใส่ชื่อจริง")
            } else if (!this.form.birthday) {
                alert("กรุณาใส่วันเกิด")
            } else if (!this.form.age) {
                alert("กรุณาใส่อายุ")
            } else if (!this.form.citizen.citizen_id) {
                alert("กรุณาใส่บัตรประจำตัวประชาชน / passport");
            } else if (!this.form.work_status.active_status_id) {
                alert("กรุณาเลือกสถานะการทำงาน");
            } else {
                this.form.birthday = moment(this.form.birthday).format("YYYY-MM-DD"); // วันเกิด
                if (this.form.work_status.start_work_date) { //วันเริ่มทำงาน
                    this.form.work_status.start_work_date = moment(this.form.work_status.start_work_date).format("YYYY-MM-DD");
                }
                if (this.form.work_status.resign_date) { //วันที่ลาออก
                    this.form.work_status.resign_date = moment(this.form.work_status.resign_date).format("YYYY-MM-DD");
                }
                if (this.form.citizen.issue_date) {  //วันออกบัตรประชาชน
                    this.form.citizen.issue_date = moment(this.form.citizen.issue_date).format("YYYY-MM-DD");
                }
                if (this.form.citizen.expire_date) { //วันบัตรประชาชนหมดอายุ
                    this.form.citizen.expire_date = moment(this.form.citizen.expire_date).format("YYYY-MM-DD");
                }
                if (this.form.work_status.visa_date) { //วันออกวรซ่า
                    this.form.work_status.visa_date = moment(this.form.work_status.visa_date).format("YYYY-MM-DD");
                }
                if (this.form.work_status.visa_expire_date) { //วันหมดอายุวีซ่า
                    this.form.work_status.visa_expire_date = moment(this.form.work_status.visa_expire_date).format("YYYY-MM-DD");
                }
                if (this.form.work_status.certificate_date) { //วันเริ่มใบทำงาน
                    this.form.work_status.certificate_date = moment(this.form.work_status.certificate_date).format("YYYY-MM-DD");
                }
                if (this.form.work_status.certificate_expire_date) { //วันหมดอายุใบทำงาน
                    this.form.work_status.certificate_expire_date = moment(this.form.work_status.certificate_expire_date).format("YYYY-MM-DD");
                }
                if (this.form.address.province) {
                    this.form.address.province_id = this.form.address.province.id;
                }
                if (this.form.address.district) {
                    this.form.address.district_id = this.form.address.district.id;
                }
                if (this.form.address.sub_district) {
                    this.form.address.sub_district_id = this.form.address.sub_district.id;
                }
                return true;

            }
        },
        differentDate() {
            if (this.form.birthday) {
                let currentDate = moment().format("YYYY");
                let birthday = moment(this.form.birthday).format("YYYY");
                let diff = parseInt(currentDate) - parseInt(birthday);
                this.form.age = diff;
            }
        },
        validatePassportNumber() {
            if (this.form.citizen.citizen_id) {
                let data = {
                    citizen_id: this.form.citizen.citizen_id
                };
                this.$store.dispatch("Employee/validatePassportNumber", data).then(res => {
                    this.validate_passport = res;
                    if (!this.validate_passport) {
                        alert('บัตรประชาชน / passport สามารถใช้ได้');
                    }
                })
            } else {
                alert('กรุณาใส่เลข Passport / บัตรประชาชน')
            }
        },
        validateEmployeeNo() {
            if (this.form.employee_no) {
                this.$store.dispatch("Employee/validateEmployeeNo", this.form.employee_no).then(res => {
                    if (res) {
                        this.validate_employee_no = res;
                        alert('รหัสพนักงานซ้ำกรุณากรอกใหม่อีกครั้ง');
                    } else {
                        this.validate_employee_no = ''
                        alert('รหัสพนักงานสามารถใช้งานได้ค่ะ');
                    }

                })
            }
        }
    }
}
</script>

<style lang="scss" scoped>
body {
    font-family: Arial, Helvetica, sans-serif;
}

* {
    box-sizing: border-box;
}

.form-inline {
    display: flex;
    flex-flow: row wrap;
}

.form-inline label {
    margin: 5px 10px 5px 0;
}

.form-inline input {
    vertical-align: middle;
    margin: 5px 10px 5px 0;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #ddd;
}

.form-inline button {
    padding: 10px 20px;
    border: 1px solid #ddd;
    color: white;
    cursor: pointer;
}

.form-inline button:hover {

}

@media (max-width: 800px) {
    .form-inline input {
        margin: 10px 0;
    }

    .form-inline {
        flex-direction: column;
        align-items: stretch;
    }
}

.padding {
    padding: 5px;
}

.margin {
    margin: 10px;
}
</style>
